/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { FacilityOpenshiftEmployeeAggregateResponse } from '../api-models';
// @ts-ignore
import { PageModelOfFacilityAggregateResponse } from '../api-models';
// @ts-ignore
import { ReportFilterRequest } from '../api-models';
// @ts-ignore
import { ReportResponse } from '../api-models';
/**
 * AdminReportsApi - axios parameter creator
 * @export
 */
export const AdminReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReportsFacilityAggregatesPost: async (reportFilterRequest?: ReportFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/AdminReports/facility-aggregates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReportsFacilityEmployeeAggregatesPost: async (reportFilterRequest?: ReportFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/AdminReports/facility-employee-aggregates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReportsPost: async (reportFilterRequest?: ReportFilterRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/AdminReports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminReportsApi - functional programming interface
 * @export
 */
export const AdminReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminReportsFacilityAggregatesPost(reportFilterRequest?: ReportFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageModelOfFacilityAggregateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminReportsFacilityAggregatesPost(reportFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminReportsFacilityEmployeeAggregatesPost(reportFilterRequest?: ReportFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilityOpenshiftEmployeeAggregateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminReportsFacilityEmployeeAggregatesPost(reportFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportFilterRequest} [reportFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminReportsPost(reportFilterRequest?: ReportFilterRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminReportsPost(reportFilterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminReportsApi - factory interface
 * @export
 */
export const AdminReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminReportsApiAdminReportsFacilityAggregatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReportsFacilityAggregatesPost(requestParameters: AdminReportsApiAdminReportsFacilityAggregatesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<PageModelOfFacilityAggregateResponse> {
            return localVarFp.adminReportsFacilityAggregatesPost(requestParameters.reportFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminReportsApiAdminReportsFacilityEmployeeAggregatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReportsFacilityEmployeeAggregatesPost(requestParameters: AdminReportsApiAdminReportsFacilityEmployeeAggregatesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<FacilityOpenshiftEmployeeAggregateResponse> {
            return localVarFp.adminReportsFacilityEmployeeAggregatesPost(requestParameters.reportFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminReportsApiAdminReportsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminReportsPost(requestParameters: AdminReportsApiAdminReportsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ReportResponse>> {
            return localVarFp.adminReportsPost(requestParameters.reportFilterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminReportsFacilityAggregatesPost operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiAdminReportsFacilityAggregatesPostRequest
 */
export interface AdminReportsApiAdminReportsFacilityAggregatesPostRequest {
    /**
     * 
     * @type {ReportFilterRequest}
     * @memberof AdminReportsApiAdminReportsFacilityAggregatesPost
     */
    readonly reportFilterRequest?: ReportFilterRequest
}

/**
 * Request parameters for adminReportsFacilityEmployeeAggregatesPost operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiAdminReportsFacilityEmployeeAggregatesPostRequest
 */
export interface AdminReportsApiAdminReportsFacilityEmployeeAggregatesPostRequest {
    /**
     * 
     * @type {ReportFilterRequest}
     * @memberof AdminReportsApiAdminReportsFacilityEmployeeAggregatesPost
     */
    readonly reportFilterRequest?: ReportFilterRequest
}

/**
 * Request parameters for adminReportsPost operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiAdminReportsPostRequest
 */
export interface AdminReportsApiAdminReportsPostRequest {
    /**
     * 
     * @type {ReportFilterRequest}
     * @memberof AdminReportsApiAdminReportsPost
     */
    readonly reportFilterRequest?: ReportFilterRequest
}

/**
 * AdminReportsApi - object-oriented interface
 * @export
 * @class AdminReportsApi
 * @extends {BaseAPI}
 */
export class AdminReportsApi extends BaseAPI {
    /**
     * 
     * @param {AdminReportsApiAdminReportsFacilityAggregatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public adminReportsFacilityAggregatesPost(requestParameters: AdminReportsApiAdminReportsFacilityAggregatesPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).adminReportsFacilityAggregatesPost(requestParameters.reportFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminReportsApiAdminReportsFacilityEmployeeAggregatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public adminReportsFacilityEmployeeAggregatesPost(requestParameters: AdminReportsApiAdminReportsFacilityEmployeeAggregatesPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).adminReportsFacilityEmployeeAggregatesPost(requestParameters.reportFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminReportsApiAdminReportsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public adminReportsPost(requestParameters: AdminReportsApiAdminReportsPostRequest = {}, options?: AxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).adminReportsPost(requestParameters.reportFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
